
/* injects from baggage-loader */
require('./style.scss');

import React, {Component} from "react";
import {Link} from "react-router";
import { SwarmDataMixin, getSwarmDataKeyForRequest } from "../../../mixins/swarmDataMixin";
import { connect } from "react-redux";
import { getSwarmSubscriptionRequestSecondPopularSports } from '../../../helpers/terminalRequests/popularSports';
import { createSelector } from "reselect";
import Helpers from "../../../helpers/helperFunctions";
import Config from "../../../config/main";
import PropTypes from 'prop-types';
import { t } from '../../../helpers/translator';

class LiveGamesHompage extends Component {

    render () {
        let { data } = this.props;
        return (
            <div className="live-contain-baner">
                <div className="live-icon-v">
                    <Link to={Config.enableAllSectionInLive  ? "/live/all/all" : "/live"}>
                        <p>{t("Live Now")}</p>
                        <div className="homepageLiveSports">
                            {data && data.map(sport => <p key={sport.alias}>
                                <span className={`live-sport-inner ${sport.alias}`}>
                                    <span className="live-sport-name">{t(sport.name)}</span>
                                    <i> - {sport.game}</i>
                                </span>
                            </p>)}
                        </div>
                    </Link>
                </div>
            </div>
        );
    }
}

LiveGamesHompage.propTypes = {
    data: PropTypes.array
};

const mapStateToProps = (_) => {
    let key = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestSecondPopularSports("live"));
    return createSelector(
        [
            state => state.swarmData.data[key] && JSON.stringify((() => {
                return Helpers.objectToArray(state.swarmData.data[key].sport).sort((a, b) => a.order - b.order).slice(0, Config.main.liveGamesCountInHomePage);
            })())
        ],
        (data) => {
            return {
                data: data && JSON.parse(data)
            };
        });
};

export default connect(mapStateToProps)(SwarmDataMixin({
    Component: LiveGamesHompage,
    ComponentWillMount: function () {
        this.swarmSubscriptionRequest = getSwarmSubscriptionRequestSecondPopularSports("live");
        this.swarmDataKey = getSwarmDataKeyForRequest(getSwarmSubscriptionRequestSecondPopularSports("live"));
    }
}));